import { render } from "./IncomingGoodsProducerModal.vue?vue&type=template&id=cdbcbe0c"
import script from "./IncomingGoodsProducerModal.vue?vue&type=script&lang=js"
export * from "./IncomingGoodsProducerModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__